import router from "@/router";
import { Subject } from "@/views/entity-investigation/data/model";
import { Ref } from "@vue/composition-api";
import { POPULATION_TYPE } from "../models";
import { objectsSummary } from "../api/summary.api";
import { UseModal } from "@/components/root/modal";
export const investigation = (p: { is_biz_user: Ref<boolean> }) => {
  return {
    investigate: async (subject: Subject, as_modal = false) => {
      console.log("subject::before", subject);

      if (subject.type === POPULATION_TYPE.FILE && !subject.cluster_id) {
        const res = await objectsSummary({
          ids: [subject.id],
          type: POPULATION_TYPE.FILE,
        });
        if (res.success) {
          // @ts-ignore
          if (!res.value[0].clusterSummary) {
            show_no_cluster_modal(subject.name);
            return;
          }
          // @ts-ignore
          subject.cluster_id = res.value[0].clusterSummary.id;
        }
        console.log("subject::after", subject);
      }
      const { state } = await import("@/views/entity-investigation/data/state");
      state.init(subject, () => {
        if (as_modal) {
          //
        } else {
          if (router().currentRoute.name !== "Investigation-drilldown") {
            setTimeout(() => {
              router().push({
                name: "Investigation-drilldown",
              });
            }, 100);
          }
        }
      });
      // close all modals
      UseModal().force_close_all();
    },
  };
};

const show_no_cluster_modal = (file_name: string) => {
  UseModal().showSimple({
    title: "No cluster found",
    desc: `No cluster found for file ${file_name}`,
    cancelBtnText: "Close",
    submitBtnText: "Got it",
  });
};
